import { Button, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { GenerateSampleSection } from "@/components";
import { Col, Row } from "@/components/customComponents";

import { ViewVoiceDetailProps } from "../types";

export function ViewVoiceDetail({ voice, sampleText, isPlaying, isLoading, onSpeak, onStop, onEdit }: ViewVoiceDetailProps) {
  return (
    <>
      <Col className="gap-md">
        <Row className="justify-between items-start gap-3">
          <Col className="gap-xs flex-1 min-w-0">
            <Text variant={TextVariants.HEADING_5_BOLD} className="[overflow-wrap:anywhere]">
              {voice?.name || "Voice"}
            </Text>
            <Text variant={TextVariants.LABEL_MEDIUM_REGULAR} className="text-gray-10 [overflow-wrap:anywhere]">
              {voice?.description || ""}
            </Text>
          </Col>
          <Button variant={ButtonVariant.SECONDARY} onClick={onEdit} aria-label="edit" className="shrink-0">
            Edit
          </Button>
        </Row>
      </Col>

      <GenerateSampleSection sampleText={sampleText} isPlaying={isPlaying} isLoading={isLoading} onSpeak={onSpeak} onStop={onStop} />
    </>
  );
}
